/**
 * login模块接口列表
 */
import axios from '@/axios/http';

const systemUser = {
 //获取系统用户列表
  getManagerList(params) {
    return axios.get('/users', {params});
  },
  //系统用户-获取用户名是否存在
  getManagerName(params) {
    return axios.get('/users/userName/'+params);
  },
  //获取角色列表（分页）
  getRoleList(params) {
    return axios.get('/roles', { params });
  },
  //系统用户-新建、编辑获取角色全列表
  getRoleListByRoleId() {
    return axios.get('roles/list');
  },
  //删除角色
  deleteRole(id) {
    return axios.delete(`/roles/role/${id}`);
  },
  //根据角色ID获取角色权限
  getAuthorization(params) {
    return axios.get('function/getAuthorization', { params });
  },
  //更新角色权限
  updateRoleAuthNew(params) {
    return axios.put('role/updateRoleAuthNew', params);
  },
  //编辑\新增-角色
  updateRoleAuth(id,params,num) {
    if(num==0){
      return axios.post('/roles/role', params);//新增
    }else{
      return axios.post('/roles/role/'+id, params);//编辑
    }
  },

  //判断角色名称是否存在
  getRoleByName(name,id) {
    return axios.get(`/roles/roleName/${name}/${id}`);
  },
  //增加系统用户
  addManager(params) {
    return axios.post('/users/user', params);
  },
  //编辑系统用户
  updateManager(id,params) {
    return axios.put('/users/user/'+id, params);
  },
  //删除系统用户
  deleteManager(id) {
    return axios.delete(`/users/user/${id}`);
  },
};

export default systemUser;



// WEBPACK FOOTER //
// ./src/api/systemUserApi.js